import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {App} from './App';
import {BrandAnalytics} from './analytics';
import {BrandProvider} from './store';
import '../creator/styles/base.css';
import '../creator/styles/shell.css';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter basename="/brand">
      <BrandProvider><App /><BrandAnalytics /></BrandProvider>
    </BrowserRouter>
  </StrictMode>,
);
